/**
 * 字符串转时间
 */
export const strToDate = (objDate) => {
    try {
        var date = null;
        switch (typeof objDate) {
            case "object":
                date = objDate;
                break;
            case "number":
                date = new Date(objDate);
                break;
            case "string":
                objDate = objDate.replace("/Date(", "").replace(")/", "").replace(/-/g, "/").replace(/T/g, " ");
                var re = /^[1-9]+[0-9]*]*$/;
                if (re.test(objDate)) {
                    date = new Date(parseInt(objDate));
                } else {
                    date = new Date(objDate);
                }
                break;
            default:
                break;
        }
        return date;
    } catch (ex) {
        return null;
    }
}

/**
 * 时间格式化
 */
export const formaterDate = (objDate, format) => {
    function formatDate(obj, format) {
        format = format || "yyyy-MM-dd HH:mm:ss";
        var o = {
            "M+": obj.getMonth() + 1, //month
            "d+": obj.getDate(), //day
            "h+": obj.getHours(), //hour
            "H+": obj.getHours(), //hour
            "m+": obj.getMinutes(), //minute
            "s+": obj.getSeconds(), //second
            "q+": Math.floor((obj.getMonth() + 3) / 3), //quarter
            "S": obj.getMilliseconds() //millisecond
        }
        if (/(y+)/.test(format)) {
            format = format.replace(RegExp.$1, (obj.getFullYear() + "").substr(4 - RegExp.$1.length));
        }
        for (var k in o) {
            if (new RegExp("(" + k + ")").test(format)) {
                format = format.replace(RegExp.$1, RegExp.$1.length == 1 ? o[k] : ("00" + o[k]).substr(("" + o[k]).length));
            }
        }
        return format;
    };

    try {
        var date = strToDate(objDate);
        if (date != null && date.getDate().toString().toLocaleLowerCase() != "nan") {
            var month = date.getMonth() + 1 < 10 ? "0" + (date.getMonth() + 1) : date.getMonth() + 1;
            var day = date.getDate() < 10 ? "0" + date.getDate() : date.getDate();
            var hours = date.getHours();
            var minutes = date.getMinutes();
            var seconds = date.getSeconds();
            var milliseconds = date.getMilliseconds();
            format = format || "yyyy-MM-dd";
            return formatDate(date, format);
        } else {
            return "";
        }
    } catch (ex) {
        console.error(ex);
    }
}